<script setup>
// регистрация
import {useField, useForm} from "vee-validate";
import * as yup from "yup";
import axios from "axios";
import {ref} from "vue";

const isDateValid = ref(true)
const isRecoverySuccess = ref(false)
const { handleSubmit, isSubmitting } = useForm();

const { value:surname, errorMessage:surnameError } = useField(
    'surname',
    yup
        .string()
        .trim()
        .required()
);
const { value:name, errorMessage:nameError } = useField(
    'name',
    yup
        .string()
        .trim()
        .required()
);
const { value:midname, errorMessage:midnameError } = useField(
    'midname',
    yup
        .string()
        .trim()
        .required()
);
const { value:date, errorMessage:dateError } = useField(
    'date',
    yup
        .string()
        .trim()
        .required()
        .length(10,'#')
);
const { value:personInfo, errorMessage:personInfoError } = useField(
    'personInfo',
    yup
        .string()
        .trim()
        .required()
);
const { value:email, errorMessage:emailError } = useField(
    'email',
    yup
        .string()
        .trim()
        .required()
        .email('')
);
//----------------------------------------------------------------------
// валидация даты рождения
const validateDate = (date) => {
  let isDateValid = true
  let dateArr = date.split('.')
  //getMonth() c 0
  let m = dateArr[1]-1
  let newDate = new Date(dateArr[2], m, dateArr[0]);
  if (newDate.getFullYear() === +dateArr[2] && newDate.getMonth() === m && newDate.getDate() === +dateArr[0]) {
    let now = new Date();
    if (dateArr[2] > now.getFullYear()-18 || dateArr[2] < now.getFullYear()-100 ){
      isDateValid = false
    }
  } else {
    isDateValid = false
  }
  return isDateValid
}

/*
// прокрутить окно вверх при ошибке
const moveToError = () => {
  const modal = document.querySelector("#contacts")
  if ((surname.value == undefined || surname.value == '')
      || (name.value == undefined || name.value == '')
      || (midname.value == undefined || midname.value == '')
      || (date.value == undefined || date.value == '')
      || (phone.value == undefined || phone.value == '')
      || (email.value == undefined || email.value == '')
  ){
    modal.scrollTo({
      behavior: 'smooth',
      top: 0,
    })
  }
}
*/

// отправить форму
const onSubmit = handleSubmit(async (values) => {

  try {
    const modal = document.querySelector("#contacts")
    isDateValid.value = validateDate(values['date'])

    console.log(isDateValid.value)

    if (!isDateValid.value){
      modal.scrollTo({
        behavior: 'smooth',
        top: 0,
      })
    }

    if (isDateValid.value) {

      //Если заголовок Content-Type имеет значение отличное от application/x-www-form-urlencoded,
      //https://qna.habr.com/q/447033
      //браузер сделает два HTTP-запроса + OPTIONS

      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
      }

      const url = process.env.VUE_APP_API + "recovery.php"
      const {data} = await axios.post(url, values, {
        headers: headers
      })

      if (data['status'] === 'SUCCESS') {
        isRecoverySuccess.value = true
      } else {
        alert ('SQL_SERVER_ERROR')
      }

    }

  } catch (e) {
    alert ('INTERNAL_SERVER_ERROR')
  }

})

//----------------------------------------------------------------------

// eslint-disable-next-line no-undef,no-unused-vars
const emit = defineEmits(['success'])

</script>

<template>

  <div class="modal-body" id="contacts">

    <form @submit="onSubmit" v-if="!isRecoverySuccess">

      <div class="row">

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="surname">Фамилия</label>
            <input
                type="text"
                id="surname"
                :class="['form-control', {'is-invalid': surnameError}]"
                v-model="surname"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="name">Имя</label>
            <input
                type="text"
                id="name"
                :class="['form-control', {'is-invalid': nameError}]"
                v-model="name"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="midname">Отчество</label>
            <input
                type="text"
                id="midname"
                :class="['form-control', {'is-invalid': midnameError}]"
                v-model="midname"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="date">Дата рождения</label>
            <input
                type="text"
                id="date"
                :class="['form-control', {'is-invalid': dateError || !isDateValid}]"
                v-mask="'##.##.####'"
                placeholder="00.00.0000"
                v-model="date"
            >
          </div>
        </div>

        <div class="col-md-8 col-sm-12">
          <div class="form-group mt-2">
            <label for="person-info">Идетнификатор договора* или номер свидетельства**</label>
            <input
                type="text"
                id="person-info"
                :class="['form-control', {'is-invalid': personInfoError}]"
                v-model="personInfo"
            >
          </div>
        </div>

        <div class="col-md-4 col-sm-12">
          <div class="form-group mt-2">
            <label for="phone">Контактный E-mail</label>
            <input
                type="text"
                id="email"
                :class="['form-control', {'is-invalid': emailError}]"
                v-model="email"
            >
          </div>
        </div>

      </div>

      <hr>

      <p>* Идентификатор договора – это уникальный 13-значный номер, который присвоен именно Вашему обязательству и по которому кредитор идентифицирует Ваши  платежи.</p>
      <p>** Номер свидетельста - это уникальный 5-значный номер в формате З-XXXXX.</p>

      <div class="text-center p-2 mb-4">
        <button
            type="submit"
            class="btn btn-send btn-block fs-15 m-auto"
            style="font-size: 1.4rem;width: 280px"
            :disabled="isSubmitting"
        >
          <svg v-if="isSubmitting"
               xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g>
            <circle cx="3" cy="12" r="2" fill="#80b5d3"/>
            <circle cx="21" cy="12" r="2" fill="#80b5d3"/>
            <circle cx="12" cy="21" r="2" fill="#80b5d3"/>
            <circle cx="12" cy="3" r="2" fill="#80b5d3"/>
            <circle cx="5.64" cy="5.64" r="2" fill="#80b5d3"/>
            <circle cx="18.36" cy="18.36" r="2" fill="#80b5d3"/>
            <circle cx="5.64" cy="18.36" r="2" fill="#80b5d3"/>
            <circle cx="18.36" cy="5.64" r="2" fill="#80b5d3"/>
            <animateTransform attributeName="transform" dur="1.5s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></g>
          </svg>
          <span v-else>Отправить</span>
        </button>
      </div>
      <p>В соответствии со статьей 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» даю согласие на обработку моих персональных данных, необходимых для предоставления услуги.</p>

      <p><strong>Указанные данные должны совпадать с регистрационными.
        В связи с большим количеством обращений, восстановление доступа может занять некотрое время.</strong></p>

    </form>

    <div v-else>
      <div class="text-center pb-2">
        <v-icon
            class="success-icon--green"
            icon="mdi:check-circle-outline"
        ></v-icon>
      </div>
      <p>После модерации пароль для доступа в «Личный кабинет клиента СПБ ЦДЖ» будет отправлен на указанный электронный адрес.</p>
    </div>
  </div>

</template>
<style scoped></style>